// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a067763b","377":"eaa5f1df","395":"76d1852f"}[chunkId] + ".chunk.js";
};